import React, { useEffect, useState, useRef } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../url';
import './Banners.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Banners() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const swiperRef = useRef(null);

    useEffect(() => {
        cargarBanners();
    }, []);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current?.update();
        }
    }, [images]);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, { method: 'GET' })
            .then(r=>r.text())
            .then(t=>{ try{ const data=JSON.parse(t); const bannerImages = (data.banner||[]).map(b => { const v=b.imagen; return (v && /^https?:/i.test(v))? v : `${baseURL}/${String(v||'').replace(/^\//,'')}`; }).reverse(); setImages(bannerImages); }catch(_){ setImages([]);} setLoading(false); })
            .catch(()=>{ setLoading(false); });
    };

    return (
        <div className='BannerContain'>

            {loading ? (
                <div className='loadingBanner'>

                </div>

            ) : (
                <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    loop={true}
                    slidesPerView={'auto'}
                    coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                    navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                    autoplay={{ delay: 3000 }}
                    pagination={{ clickable: true }}
                    preloadImages={false}
                    observer={true}
                    observeParents={true}
                    onSwiper={(swiper) => {
                        console.log(swiper);
                        swiperRef.current = swiper;
                    }}
                    id='swiper_container'
                >
                    {images?.map((image, index) => (
                        <SwiperSlide id='SwiperSlide-scroll' key={index}>
                            <img
                                loading='lazy'
                                decoding='async'
                                fetchpriority={index===0?'high':'auto'}
                                src={image}
                                alt={`imagen-${index}`}
                                sizes='(max-width: 1024px) 100vw, 1200px'
                                width={1200}
                                height={400}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}


        </div>
    );
}
